module.exports = __webpack_public_path__ + "img/color-1.5611f10.webp";